import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import { useGlobalContext } from '../../Context/GlobalContext';

const PresentAndHalfDayModal = ({
    type,
    modalHeading,
    isOpenModal,
    isCloseModal,
    updateStatus,
    punchRecordId,
    fetchAttendanceSummary,
    punchDate
}) => {
    const { openToast, fetchShifts, shift: allShift } = useGlobalContext();

    const [updatedDetail, setUpdatedDetail] = useState({
        startTime: '',
        endTime: '',
        shiftId: '',
    });
    const [loading, setLoading] = useState(false); // Loading state to disable the button

    useEffect(() => {
        fetchShifts();
    },[])
    const handleSave = async () => {
        if (!updatedDetail?.shiftId) {
            openToast(`Please select a shift for ${type} status`, 'warning');
            return;
        }

        if (!updatedDetail.startTime || !updatedDetail.endTime) {
            openToast('Start Time and End Time are required', 'warning');
            return;
        }

        const data = {
            status: type,
            ...updatedDetail,
            startTime: new Date(
                `${new Date().toDateString()} ${updatedDetail?.startTime}`
            ).toISOString(),
            endTime: new Date(
                `${new Date().toDateString()} ${updatedDetail?.endTime}`
            ).toISOString(),
        };

        try {
            setLoading(true); // Disable the button during API call
            await updateStatus(punchRecordId, data); // Update status
            isCloseModal(); // Close the modal
            fetchAttendanceSummary()
        } catch (error) {
            openToast('Error occurred while updating status', 'error'); // Display error toast
        }
        finally{
            setLoading(false);
        }
    };

    return (
        <Modal open={isOpenModal} onClose={isCloseModal} center className="bg-transparent shadow-none">
            <div className="pt-5">
                <div className="flex justify-between items-center mb-6">
                    <div>
                        <h1 className="font-medium text-[22px] text-gray-900">{type}</h1>
                        <p className="text-gray-600 text-sm">{modalHeading}</p>
                    </div>
                </div>

                <div className="relative p-4 pr-0 pl-0">
                    <div className="space-y-4">
                        {/* Shift Selection */}
                        <div>
                            <label className="block mb-1 text-[#000] text-sm">Shift Name</label>
                            <div className="relative">
                                <select
                                    value={updatedDetail.shiftId}
                                    onChange={(e) =>
                                        setUpdatedDetail({ ...updatedDetail, shiftId: e.target.value })
                                    }
                                    className="bg-white px-3 py-2 pr-10 border border-gray-200 rounded-md focus:outline-none w-full text-gray-600 appearance-none"
                                >
                                    <option value="">Select Shift</option>
                                    {allShift?.map((shift) => (
                                        <option key={shift.id} value={shift.id}>
                                            {`${shift.shiftName} (${shift.shiftStartTime} - ${shift.shiftEndTime})`}
                                        </option>
                                    ))}
                                </select>
                                <div className="right-0 absolute inset-y-0 flex items-center px-2 pointer-events-none">
                                    <svg
                                        className="w-4 h-4 text-gray-400"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M19 9l-7 7-7-7"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        {/* Time Inputs */}
                        <div className="gap-4 grid grid-cols-2">
                            <div>
                                <label className="block mb-1 text-[#000] text-sm">Start Time</label>
                                <input
                                    type="time"
                                    value={updatedDetail?.startTime}
                                    onChange={(e) =>
                                        setUpdatedDetail({ ...updatedDetail, startTime: e.target.value })
                                    }
                                    className="px-3 py-2 border border-gray-200 rounded-md focus:outline-none w-full text-gray-600 placeholder-gray-400"
                                />
                            </div>
                            <div>
                                <label className="block mb-1 text-[#000] text-sm">End Time</label>
                                <input
                                    type="time"
                                    value={updatedDetail?.endTime}
                                    onChange={(e) =>
                                        setUpdatedDetail({ ...updatedDetail, endTime: e.target.value })
                                    }
                                    className="px-3 py-2 border border-gray-200 rounded-md focus:outline-none w-full text-gray-600 placeholder-gray-400"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Save Button */}
                <button
                    className={`second-btn w-full ${loading ? 'cursor-not-allowed animate-pulse' : ''}`}
                    onClick={handleSave}
                    disabled={loading} // Disable button during loading
                >
                    {loading ? 'Saving...' : 'Save'}
                </button>
            </div>
        </Modal>
    );
};

export default PresentAndHalfDayModal;
